import PropTypes from 'prop-types';
import { InferPropTypes } from '../../../interfaces/inferPropTypes';
import Image from '../../Image';
import IconNext from '../images/icon-next.svg';
const paginatePropTypes = {
    pages: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    module: PropTypes.string.isRequired,
    previous: PropTypes.func.isRequired,
    next: PropTypes.func.isRequired,
};

const paginateDefaultProps = {
    pages: 10,
    page: 1,
    limit: 5, // limite para colocar puntos suspensivos
    previous: () => {
        console.log('');
    },
    next: () => {
        console.log('');
    },
};

type PaginateProps = InferPropTypes<typeof paginatePropTypes, typeof paginateDefaultProps>;

const Paginate = ({ pages, page, limit, previous, next }: PaginateProps): JSX.Element => {
    return (
        <nav className="flex items-center justify-between px-4 sm:px-0 ">
            <div className="md:-mt-px md:flex items-center mx-auto flex justify-between">
                <div className="" onClick={(e) => pages > 0 && page > 1 && previous(e, page - 1)}>
                    <Image
                        className={`
                        xl:w-[95px] xl:h-[95px]
                        lg:w-[95px] lg:h-[95px]
                        w-[80px] h-[80px]
                        block ${pages > 0 && page > 1 ? 'cursor-pointer ' : ''} 
                        !rounded-full
                        border-sm-integrate rotate-180`}
                        imgClassName={`rounded-full`}
                        src={IconNext}
                        alt="After"
                        height={95}
                        width={95}
                    />
                </div>

                <div className="hidden xl:block lg:block pagination-numbers text-white">
                    {(() => {
                        const options = [];
                        if (pages > limit + 1) {
                            for (let i = page > 3 ? page - 3 : 1; i <= page; i++) {
                                options.push(
                                    <span
                                        onClick={(e) => i !== page && next(e, i)}
                                        key={'page-number' + i}
                                        className={`italic ${
                                            i === page ? 'text-green-600 font-bold text-[40px]' : 'text-[35px]'
                                        } ${i === page ? '' : 'cursor-pointer'}`}
                                    >{`${i <= pages - 1 ? i + ((i < page || page === pages - 1) && '-') : i}`}</span>,
                                );
                            }

                            /* options.push(
                                <span
                                    key={`paginate-list-ranking-pages-${pages}limit${limit}`}
                                    onClick={(e) => page === pages && next(e, page === pages ? 1 : page)}
                                    className={`italic text-[35px] ${
                                        page === pages ? '' : 'text-green-600 font-bold'
                                    } ${page === pages ? 'cursor-pointer ' : ''}`}
                                >
                                    {page === pages ? 1 : page}
                                </span>,
                            );*/
                            pages - 1 > page && options.push(<span className="italic text-[35px]">....</span>);
                            pages > page &&
                                options.push(
                                    <span
                                        onClick={(e) => page !== pages && next(e, page === pages ? page : pages)}
                                        className={`italic text-[35px] ${
                                            page === pages ? 'text-green-600 font-bold' : ''
                                        } ${page === pages ? '' : 'cursor-pointer '}`}
                                    >
                                        {pages}
                                    </span>,
                                );
                        } else {
                            for (let i = 1; i <= pages; i++) {
                                options.push(
                                    <span
                                        onClick={(e) => i !== page && next(e, i)}
                                        key={'page-number' + i}
                                        className={`italic ${
                                            i === page ? 'text-green-600 font-bold text-[40px]' : 'text-[35px]'
                                        } ${i === page ? '' : 'cursor-pointer'}`}
                                    >{`${i <= pages - 1 ? i + '-' : i}`}</span>,
                                );
                            }
                        }

                        return options;
                    })()}
                </div>
                <div className="block xl:hidden lg:hidden pagination-numbers-mobile text-white">
                    <span
                        onClick={(e) => page === pages && next(e, page === pages ? 1 : page)}
                        className={`italic xl:text-[35px] lg:text-[35px] text-[25px] ${
                            (page !== pages && pages > 1) || (page === 1 && pages <= 1)
                                ? 'text-green-600 font-bold'
                                : ''
                        }  ${page === pages ? 'cursor-pointer ' : ''}`}
                    >
                        {page === pages ? 1 : page}
                    </span>
                    {pages > 1 && (
                        <>
                            <span className="italic xl:text-[35px] lg:text-[35px] text-[25px]">....</span>
                            <span
                                onClick={(e) => page !== pages && next(e, page === pages ? page : pages)}
                                className={`italic xl:text-[35px] lg:text-[35px] text-[25px] ${
                                    page === pages ? 'text-green-600 font-bold' : ''
                                } ${page === pages ? '' : 'cursor-pointer '}`}
                            >
                                {pages}
                            </span>
                        </>
                    )}
                </div>
                <div className="" onClick={(e) => pages > 0 && pages > page && next(e, page + 1)}>
                    <Image
                        className={`
                            xl:w-[95px] xl:h-[95px]
                            lg:w-[95px] lg:h-[95px]
                            w-[80px] h-[80px]
                            block ${pages > 0 && pages > page ? 'cursor-pointer ' : ''} 
                            !rounded-full
                            border-sm-integrate	`}
                        imgClassName={`rounded-full`}
                        src={IconNext}
                        alt="Next"
                        height={95}
                        width={95}
                    />
                </div>
            </div>
        </nav>
    );
};
Paginate.defaultProps = paginateDefaultProps;

export default Paginate;
